import { defineMessages } from 'react-intl';

export default defineMessages({
	learnMoreLinkLabel: {
		defaultMessage: 'Learn more about testing single sign-on',
		description: 'label for learn more link for sso test mode failure',
		id: 'cv.login.ca.sso.test.mode.error.learn.more.label',
	},
	instructionMessage: {
		defaultMessage: 'Turn on the single sign-on test mode in your Authentication settings.',
		description: 'message with instruction for SSO test mode',
		id: 'cv.login.ca.sso.test.mode.error.instruction.message',
	},
	title: {
		defaultMessage: 'Single Sign-on test mode is disabled',
		description: 'title for SSO test mode error page',
		id: 'cv.login.ca.sso.test.mode.error.title',
	},
});
